module.exports = __webpack_public_path__ + "static/img/ico_logo.eb03594.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/ico_logo.png
// module id = fFHd
// module chunks = 0